export const GET_RESTRICTED_RICHTEXT_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query{
    restrictedRichTextBlock(id: "${id}", preview: ${preview}) {
     sys {
        id
      }
      audienceCollection{
        items{
            __typename
            sys{id}
            audianceId
          }
      }
      body {
        json
        links{
            entries {
                hyperlink {
                    ... on Page {
                        sys {
                        id
                        }
                        slug
                        content {
                        __typename
                        }
                    }
                    ... on Link {
                      __typename
                      sys {
                          id
                      }
                      globalLinkItem
                      reference {
                        ... on Page {
                          sys {
                            id
                          }
                          slug
                          content {
                            __typename
                            }
                        }
                      }
                      url
                    }
                }
            }
        }
    }
    }
  }
`;
